import React, { useContext, useEffect, useRef, useState } from "react";
import ModalContext from "../../Contexts/openModal";
import DemoModal from "../DemoModal";
import CTAPicasso from "./CTA Picasso";
import CareerBenefits from "./CareerBenefits";
import Company from "./Company";
import DiagramMonet from "./DiagramMonet";
import FeatureDali from "./FeatureDali";
import FeatureDegard from "./FeatureDegard";
import FeatureKlimt from "./FeatureKlimt";
import FeatureMatisse from "./FeatureMatisse";
import FeatureMonet from "./FeatureMonet";
import { FeatureMunch } from "./FeatureMunch";
import FeaturePicasso from "./FeaturePicasso";
import FeatureRaphael from "./FeatureRaphael";
import FeatureTurner from "./FeatureTurner";
import FooterBanner from "./FooterBanner";
import FooterRaphael from "./FooterRaphael";
import FormKusama from "./FormKusama";
import FormMonet from "./FormMonet";
import Formcc96010fd9a642e1a736c9ce8ffc8a78Monet from "./Formcc96010fd9a642e1a736c9ce8ffc8a78Monet";
import { HeroDali } from "./HeroDali";
import HeroKusama from "./HeroKusama";
import HeroMonet from "./HeroMonet";
import HeroRaphael from "./HeroRaphael";
import HeroSupportingAssetMonet from "./HeroSupportingAssetMonet";
import JobListingMonet from "./JobListingMonet";
import LogosDali from "./LogosDali";
import { LogosMonet } from "./LogosMonet";
import { SectionDali } from "./SectionDali";
import SectionKahlo from "./SectionKahlo";
import SectionKusama from "./SectionKusama";
import { SectionMonet } from "./SectionMonet";
import SectionPollock from "./SectionPollock";
import SectionVinci from "./SectionVinci";
import SectionWarhol from "./SectionWarhol";
import StatsMonet from "./StatsMonet";
import TestimonialMonet from "./TestimonialMonet";
import TestimonialRaphael from "./TestimonialRaphael";
import TestimonialTurner from "./TestimonialTurner";
import HomepageQuiz from "./HomepageQuiz";
import CellMonet from "./CellMonet";
import ImageMonet from "./ImageMonet";
import SectionRaphael from "./SectionRaphael";
import SectionTurner from "./SectionTurner";
import SectionMunch from "./SectionMunch";
import SectionHopper from "./SectionHopper";
import CarouselMonet from "./CarouselMonet";
import SectionRand from "./SectionRand";
import SectionVermeer from "./SectionVermeer";
import SectionMoore from "./SectionMoore";
import FAQ from "./FAQ";
import { SectionComparison } from "./SectionComparison";
import PricingMonet from "./PricingMonet";
import TestimonialDali from "./TestimonialDali";
import TableDaliParent from "./TableDaliParent";
import TableTurner from "./TableTurner";
import FeatureLewitt from "./FeatureLewitt";
import HeroTurner from "./HeroTurner";
import HeroMondrian from "./HeroMondrian";
import CustomButton from "../CustomButton";
import { motion, AnimatePresence } from "framer-motion";
import CarouselTurner from "./CarouselTurner";
import HeroWeiwei from "./HeroWeiwei";
import SectionsAdkins from "./SectionAdkins";
import SectionCarter from "./SectionCarter";
import SectionBell from "./SectionBell";
import SectionRamsay from "./SectionRamsay";
import HeroLewitt from "./HeroLewitt";

const allSlices = {
  section_ramsay: (slice) => <SectionRamsay {...{ slice }} />,
  section_bell: (slice) => <SectionBell {...{ slice }} />,
  section_carter: (slice, location) => (
    <SectionCarter {...{ slice, location }} />
  ),
  section_adkins: (slice, location) => (
    <SectionsAdkins {...{ slice, location }} />
  ),
  hero_weiwei: (slice) => <HeroWeiwei {...{ slice }} />,
  hero_raphael: (slice) => <HeroRaphael {...{ slice }} />,
  feature_picasso: (slice, location) => (
    <FeaturePicasso {...{ slice, location }} />
  ),
  form_cc96010fd9a642e1a736c9ce8ffc8a78_monet: (slice, location) => (
    <Formcc96010fd9a642e1a736c9ce8ffc8a78Monet {...{ slice, location }} />
  ),
  cell_monet: (slice, location) => <CellMonet {...{ slice, location }} />,
  image_monet: (slice, location) => <ImageMonet {...{ slice, location }} />,
  quiz_result: null,
  homepage_quizform: null,
  section_dali: (slice) => <SectionDali {...{ slice }} />,
  section_monet: (slice, location) => <SectionMonet {...{ slice, location }} />,
  footer_banner: (slice, location) => <FooterBanner {...{ slice, location }} />,
  footer_raphael: (slice, location) => (
    <FooterRaphael {...{ slice, location }} />
  ),
  form_kusama: (slice, location) => <FormKusama {...{ slice, location }} />,
  testimonial_raphael: (slice) => <TestimonialRaphael {...{ slice }} />,
  hero_supporting_asset_monet: (slice) => (
    <HeroSupportingAssetMonet {...{ slice }} />
  ),
  logos_monet: (slice, location) => <LogosMonet {...{ slice, location }} />,
  hero_dali: (slice, location) => <HeroDali {...{ slice, location }} />,
  logos_dali: (slice, location) => <LogosDali {...{ slice, location }} />,
  section_vinci: (slice, location) => <SectionVinci {...{ slice, location }} />,
  section_warhol: (slice, location) => (
    <SectionWarhol {...{ slice, location }} />
  ),

  section_turner: (slice, location) => (
    <SectionTurner {...{ slice, location }} />
  ),
  section_hopper: (slice, location) => (
    <SectionHopper {...{ slice, location }} />
  ),
  feature_munch: (slice, location) => <FeatureMunch {...{ slice, location }} />,
  section_kusama: (slice) => <SectionKusama {...{ slice }} />,
  stats_monet: (slice, location) => <StatsMonet {...{ slice, location }} />,
  section_pollock: (slice, location) => (
    <SectionPollock {...{ slice, location }} />
  ),
  hero_kusama: (slice, location) => <HeroKusama {...{ slice, location }} />,
  section_kahlo: (slice, location) => <SectionKahlo {...{ slice, location }} />,
  section_vermeer: (slice, location) => (
    <SectionVermeer {...{ slice, location }} />
  ),
  feature_turner: (slice) => <FeatureTurner {...{ slice }} />,
  testimonial_monet: (slice) => <TestimonialMonet {...{ slice }} />,
  feature_monet: (slice) => <FeatureMonet {...{ slice }} />,
  feature_degard: (slice) => <FeatureDegard {...{ slice }} />,
  feature_matisse: (slice) => <FeatureMatisse {...{ slice }} />,
  testimonial_turner: (slice) => <TestimonialTurner {...{ slice }} />,
  feature_raphael: (slice) => <FeatureRaphael {...{ slice }} />,
  feature_klimt: (slice) => <FeatureKlimt {...{ slice }} />,
  homepage_quiz: (slice, location) => <HomepageQuiz {...{ slice, location }} />,
  career_jobs: (slice) => <JobListingMonet {...{ slice }} />,
  career_benifets: (slice) => <CareerBenefits {...{ slice }} />,
  // Company perks / Monet^^
  company: (slice, location) => <Company {...{ slice, location }} />,
  // Carousel / Monet^^
  diagram_monet: (slice, location) => <DiagramMonet {...{ slice, location }} />,
  section_raphael: (slice, location) => (
    <SectionRaphael {...{ slice, location }} />
  ),
  section_munch: (slice, location) => <SectionMunch {...{ slice, location }} />,
  section_rand: (slice, location) => <SectionRand {...{ slice, location }} />,
  carousel_monet: (slice, location) => (
    <CarouselMonet {...{ slice, location }} />
  ),
  form_monet: (slice, location) => <FormMonet {...{ slice, location }} />,
  feature_dali: (slice, location) => <FeatureDali {...{ slice, location }} />,
  section___moore: (slice, location) => (
    <SectionMoore {...{ slice, location }} />
  ),
  hero_monet: (slice, location) => <HeroMonet {...{ slice, location }} />,
  cta_picasso: (slice, location) => <CTAPicasso {...{ slice, location }} />,
  frequent_questions: (slice, location) => <FAQ {...{ slice, location }} />,
  section_comparison: (slice, location) => (
    <SectionComparison {...{ slice, location }} />
  ),
  pricing_monet: (slice, location) => <PricingMonet {...{ slice, location }} />,
  testimonial_dali: (slice, location) => (
    <TestimonialDali {...{ slice, location }} />
  ),
  table_dali: (slice, location) => <TableDaliParent {...{ slice, location }} />,
  table_turner: (slice, location) => <TableTurner {...{ slice, location }} />,
  feature_lewitt: (slice, location) => (
    <FeatureLewitt {...{ slice, location }} />
  ),
  hero_turner: (slice, location) => <HeroTurner {...{ slice, location }} />,
  hero_mondrian: (slice, location) => <HeroMondrian {...{ slice, location }} />,
  carousel_turner: (slice, location) => (
    <CarouselTurner {...{ slice, location }} />
  ),
  hero_lewitt: (slice, location) => <HeroLewitt {...{ slice, location }} />,
};

const Slices = ({ slices, location }) => {
  const { isOpen, toggleModal, email, title, setTitle } =
    useContext(ModalContext);
  const tryItFreePage = location?.pathname === "/demo/";

  // Add check for ai-data-chats page
  const isAiVideoPage =
    location?.pathname === "/ai-data-chats/" ||
    location?.pathname?.includes("/ai-data-chats/") ||
    location?.pathname === "/ai-after-hours/" ||
    location?.pathname?.includes("/ai-after-hours/");

  const [quizSlices, setQuizSlices] = useState([]);
  const [quizResults, setQuizResults] = useState([]);
  const [quizForms, setQuizForms] = useState([]);
  const heroRef = useRef(null);
  const [showCTA, setShowCTA] = useState(false);
  const showCTALocation =
    location?.pathname === "/" ||
    location?.pathname === "/annotate/" ||
    location?.pathname === "/encord-index/" ||
    location?.pathname === "/data-agents/";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowCTA(!entry.isIntersecting); // hide if hero is in view
      },
      { threshold: 0.1 },
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) observer.unobserve(heroRef.current);
    };
  }, []);

  useEffect(() => {
    // Filter each slice type separately
    const newQuizSlices =
      slices?.prismicPageV3?.data?.body
        ?.filter((slice) => slice.slice_type === "homepage_quiz")
        ?.map((slice) => slice) || [];
    const newQuizResults =
      slices?.prismicPageV3?.data?.body
        ?.filter((slice) => slice.slice_type === "quiz_result")
        ?.map((slice) => slice) || [];

    const newQuizForms =
      slices?.prismicPageV3?.data?.body
        ?.filter((slice) => slice.slice_type === "homepage_quizform")
        ?.map((slice) => slice) || [];

    setQuizSlices(newQuizSlices);
    setQuizResults(newQuizResults);
    setQuizForms(newQuizForms);
  }, [slices]);

  const newTableDaliSlices =
    slices?.prismicPageV3?.data?.body
      ?.filter((slice) => slice.slice_type === "table_dali")
      ?.map((slice) => slice) || [];
  const newPriceSlices =
    slices?.prismicPageV3?.data?.body
      ?.filter((slice) => slice.slice_type === "pricing_monet")
      ?.map((slice) => slice) || [];
  const newTableTurnerSlices =
    slices?.prismicPageV3?.data?.body
      ?.filter((slice) => slice.slice_type === "table_turner")
      ?.map((slice) => slice) || [];
  const quizIndex = slices?.prismicPageV3?.data?.body?.findIndex(
    (slice) => slice.slice_type === "homepage_quiz",
  );
  const pricingCardIndex = slices?.prismicPageV3?.data?.body?.findIndex(
    (slice) => slice.slice_type === "pricing_monet",
  );
  const tableTurnerIndex = slices?.prismicPageV3?.data?.body?.findIndex(
    (slice) => slice.slice_type === "table_turner",
  );
  const tableDaliIndex = slices?.prismicPageV3?.data?.body?.findIndex(
    (slice) => slice.slice_type === "table_dali",
  );

  const isbannerTitle = slices?.prismicPageV3?.data?.banner_title?.text;
  const lidar = location?.pathname === "/lidar/";
  const noStickyCTAPages =
    location?.pathname == "/demo" || location?.pathname == "/careers/";
  return (
    <>
      <div>
        {isbannerTitle && (
          <p
            className={`text-xs font-medium font-mono -mb-[120px] sm:-mb-40 mt-20 ${isbannerTitle === "LiDAR" ? "" : "uppercase"} lg:mt-40 lg:-mb-[200px] font-semibold  sm:font-medium sm:text-base text-purple-1500 tracking-[1.2px] sm:tracking-widest_1 mx-auto text-center flex justify-center`}
          >
            {isbannerTitle}
          </p>
        )}

        {slices?.prismicPageV3?.data?.body?.map((slice, index) => {
          const renderer = allSlices[slice?.slice_type];
          const isQuizSpot = index === quizIndex;
          const isPricingCardSpot = index === pricingCardIndex;
          const isTableDaliSpot = index === tableDaliIndex;
          const isTableTurnerSpot = index === tableTurnerIndex;

          if (
            slice?.slice_type === "quiz_result" ||
            slice?.slice_type === "homepage_quizform"
          ) {
            return null;
          }
          return (
            <React.Fragment key={`slice_${slice?.id}`}>
              <div
                className={`${
                  index === 0
                    ? slice.slice_type === "hero_raphael"
                      ? ""
                      : slice.slice_type === "hero_dali" && isbannerTitle
                        ? " pt-32 sm:pt-60 "
                        : isAiVideoPage
                          ? ""
                          : "pt-[88px] sm:pt-32"
                    : ""
                } ${tryItFreePage && "!pt-0"}`}
                ref={index === 0 && !noStickyCTAPages ? heroRef : null}
              >
                {slice?.slice_type === "pricing_monet"
                  ? renderer(
                      isPricingCardSpot && newPriceSlices.length > 0 ? (
                        <PricingMonet
                          slice={newPriceSlices}
                          location={location}
                        />
                      ) : null,
                    )
                  : slice?.slice_type === "table_dali"
                    ? renderer(
                        isTableDaliSpot && newTableDaliSlices.length > 0 ? (
                          <TableDaliParent
                            slice={newTableDaliSlices}
                            location={location}
                          />
                        ) : null,
                      )
                    : slice?.slice_type === "table_turner"
                      ? renderer(
                          isTableTurnerSpot &&
                            newTableTurnerSlices.length > 0 ? (
                            <TableTurner
                              slice={newTableTurnerSlices}
                              location={location}
                            />
                          ) : null,
                        )
                      : renderer
                        ? renderer(slice, location, toggleModal)
                        : null}
              </div>
              {isQuizSpot && quizSlices.length > 0 && (
                <HomepageQuiz
                  slices={quizSlices}
                  quizResults={quizResults}
                  quizForms={quizForms}
                  location={location}
                />
              )}
            </React.Fragment>
          );
        })}
        <AnimatePresence>
          {showCTA && showCTALocation && (
            <motion.div
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 100, opacity: 0 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
              className="fixed bottom-0 left-0 w-full flex items-center flex-col gap-5 sm:flex-row-reverse justify-between lg:hidden bg-white pt-4 pb-6 px-4 sm:px-12 z-20 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]"
            >
              <CustomButton
                isFullWidth
                data-heap={`Sticky CTA Button ${location?.pathname}`}
                onClick={() => {
                  setTitle("Schedule a demo");
                  toggleModal();
                }}
                text="Book a demo"
                buttonClass="bg-purple-1500 text-white hover:bg-[#5E24FF] w-full sm:max-w-[312px]"
              />
              <div className="flex items-center justify-between gap-5">
                <p className="text-center text-gray-2500  text-sm sm:text-base font-normal font-inter -tracking-[0.35] sm:-tracking-[0.4px]">
                  Trusted by 200+ top AI teams
                </p>
                <img
                  src="https://images.prismic.io/encord/aEF-fLh8WN-LVppV_Frame1000004791.png?auto=format,compress"
                  alt="G2 review"
                  className="max-w-[86px]"
                />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <DemoModal
        title={lidar ? "Join the physical AI waitlist" : title}
        isOpen={isOpen}
        email={email}
        closeModal={toggleModal}
        location={location}
      />
    </>
  );
};

export default Slices;
